import { io } from "socket.io-client";


const URL =
  process.env.REACT_APP_SOCKET_URL ||
  process.env.REACT_APP_BASE_URL ||
  `${window.location.protocol}//${window.location.host}`;


const socket = io(URL, {
  autoConnect: false,
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 30000,
  transports: ["websocket"]
});


export default socket;
